<template>
  <l-modal :showing="showing" text="Attainments" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Name</b>
          <br />
          <l-input
            placeholder="Enter 'Name'"
            v-model="editObj.name"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Assessement Regime ID</b>
          <br />
          <l-select
            v-model="editObj.assessmentregime_id"
            class="text-xs"
            :data="assessmentregimes"
            :multiple="false"
          >
            <l-option
              v-for="i in assessmentregimes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Comment</b>
          <br />
          <l-input
            placeholder="Enter 'Comment'"
            v-model="editObj.comment"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: ["showing", "attainments", "selected", "isnew", "assessmentregimes"],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      // debugger;
      return Object.assign({}, this.selected);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      // debugger;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>